import { Box, Button, CardContent, Divider, IconButton, Typography, makeStyles } from "@material-ui/core";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { CardContainer, CardRoot } from "./styles";

type Props = {
  label: string;
  text: string;
  isFocused: boolean;
  setCurrentClip: (clip: any) => void;
  
}

const AudioCard = ({ label, text, setCurrentClip, isFocused, ...rest }: Props) => {

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    iconBtn: {
      width: 20,
      height: 20,
      padding: 20
    },
    playIcon: {
      height: 20,
      width: 20,
      color: 'red',
      fill: theme.palette.primary.light ?? '#7F7F7F' //talvez redefinir para o segundo tema default
    },
    title: {
      fontSize: 16,
      color: '#7F7F7F',
    },
    divider: {
      backgroundColor: theme.palette.primary.light ?? '#B1B1B1'
    },
    description: {
      fontSize: 14,
      color: '#7F7F7F',
    }
  }));

  const classes = useStyles();

  function formatClipDataAndReturnToParent() {
    const clip = {
      playerLabel: `${label} - ${text}`,
      ...rest
    }

    setCurrentClip(clip);
  }

  return (
    <CardRoot $isFocused={isFocused}>
        <Box className={classes.root} onClick={formatClipDataAndReturnToParent}>
      
          <CardContainer>
            <CardContent >
              <Typography className={classes.title}  variant="body2" color="textSecondary">
                {label}
              </Typography>
              <Divider className={classes.divider} />
              <Typography className={classes.description} variant="body1" color="textSecondary">
                {text}
              </Typography>
            </CardContent>

            <IconButton className={classes.iconBtn} aria-label="play/pause" >
              <PlayArrowIcon className={classes.playIcon} />
            </IconButton>
          </CardContainer>

        </Box>
    </CardRoot>
  )
};

export default AudioCard;